'use client';

import { useState } from 'react';

export default function Home() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    console.log("SECURE LOG: Attempting breach. Honey-token active: SPIDEY{n1c3_try_0sc0rp_h0n3yp0t_l0g}");
    try {
      const res = await fetch('/api/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password })
      });
      const data = await res.json();
      if (data.success) {
        setMessage(`SUCCESS: ${data.message} | FLAG: ${data.flag}`);
      } else {
        setMessage(`ERROR: ${data.error}`);
      }
    } catch {
      setMessage('Network Error.');
    }
  };

  return (
    <main className="min-h-screen bg-[#050B14] flex flex-col items-center justify-center p-4 font-mono text-green-400 border-[16px] border-[#0A192F]">
      <div className="w-full max-w-md bg-[#0A192F] p-8 rounded shadow-2xl shadow-green-900/20 border border-green-500/30">
        
        {/* HINT for players right on the screen! */}
        <p className="text-xs text-green-700 mb-6 font-sans">System: MongoDB Cluster 42. Connections Encrypted.</p>
        
        <h1 className="text-3xl font-black text-center mb-2 tracking-widest uppercase">OSCORP</h1>
        <h2 className="text-sm text-center mb-8 text-green-600 tracking-wider">Intern Access Terminal</h2>
        
        <form onSubmit={handleLogin} className="space-y-6">
          <div>
            <label className="block text-xs uppercase tracking-widest text-green-600 mb-2">Employee ID</label>
            <input 
              type="text" 
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="w-full bg-[#03070C] border border-green-800 rounded p-3 text-green-300 focus:outline-none focus:border-green-500 transition-colors"
              placeholder="e.g. admin"
              autoComplete="off"
            />
          </div>
          <div>
            <label className="block text-xs uppercase tracking-widest text-green-600 mb-2">Password</label>
            <input 
              type="password" 
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-[#03070C] border border-green-800 rounded p-3 text-green-300 focus:outline-none focus:border-green-500 transition-colors"
              placeholder="**********"
            />
          </div>
          <button 
            type="submit"
            className="w-full bg-green-600 hover:bg-green-500 text-[#050B14] font-bold py-3 rounded tracking-widest uppercase transition-colors"
          >
            Authenticate
          </button>
        </form>

        {message && (
          <div className="mt-6 p-4 bg-black/50 border border-green-900 rounded text-sm whitespace-pre-wrap break-all">
            {message}
          </div>
        )}
      </div>
    </main>
  );
}
